import api from "../api";

export class ProjectsService {

    static fetchProjects(){return api.get('/projects/list').catch(e=>console.log(e))}
    static fetchProjectsByUrl(url){ return api.get(url.split('/api/v1/')[1]).catch(e=>console.log(e))}
    static createProject(data){
        return api.post(`/projects/create`,data).catch(e=>{
            console.log(e);
        })
    }
    static fetchTaskList(project_type_id,project_id){return api.get(`projects/task-menu/${project_type_id}/${project_id}`).catch(e=>console.log(e))}
    static fetchProjectInfo(project_id){ return api.get(`projects/${project_id}`) }

    static remarkProject(data, project_id){
        return api.post(`projects/approve/${project_id}`,data).catch(e=>{ console.log(e);})
    }
    static fetchProjectUsers(project_id){return api.get(`projects/team-members/${project_id}`).catch(e=>{ console.log(e);})}
    static fetchProjectUsersHistory(project_id){return api.get(`projects/team-members-history/${project_id}`).catch(e=>{ console.log(e);})}

    static fetchRequiredDocuments(project_type_id,task_id) {return api.get(`projects/document-list/${project_type_id}/${task_id}`).catch(e=>{ console.log(e);})}

    static createProjectUser(data){
        return api.post(`projects/team-members/create`,data).catch(e=>{
            console.log(e);
        })
    }

    static addProjectUser(data){
        return api.post(`projects/team-members/add`,data).catch(e=>{
            console.log(e);
        })
    }
    static fetchMonitoringProjects(){return api.get('/projects/monitoring').catch(e=>console.log(e))}

    static fetchSignatories(project_id) {return api.get(`projects/signatories/${project_id}`)}
    static fetchProjectLocalities(project_id) {return api.get(`projects/localities/${project_id}`)}
    static fetchParcelInfo(parcel_id){ return api.get(`projects/parcels/info/${parcel_id}`)}
    static fetchPartyInfo(parcel_id){ return api.get(`projects/parcels/parties/${parcel_id}`)}
    static fetchProjectStats(){return api.get('projects/stats').catch(e=>console.log(e))}
    static fetchProjectStatsByType(project_type_id){return api.get(`projects/stats?project_type_id=${project_type_id}`).catch(e=>console.log(e))}
    static fetchPublishedProjects(locality_id=null){return api.get(locality_id === null ? `projects/published`
        : `projects/published?locality_id=${locality_id}`).catch(e=>console.log(e))}

    static fetchLandUses(){return api.get('/projects/list').catch(e=>console.log(e))}

    static searchProjects(project_type_id, status_id, project_name){
        return api.get(`/projects/list/${project_type_id}/${status_id}/${project_name}`).catch(e=>console.log(e))}

}
